import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FileUploadModule } from 'ng2-file-upload';
import { FileDialogComponent } from './file-dialog/file-dialog.component';
import { SharedDirectivesModule } from '../directives/shared-directives.module';
import { SharedPipesModule } from '../pipes/shared-pipes.module';
import { BtnLoadingComponent } from './btn-loading/btn-loading.component';
import { CheckboxSelectFilterComponent } from './checkbox-select-filter/checkbox-select-filter.component';
import { CheckboxSelectComponent } from './checkbox-select/checkbox-select.component';
import { CheckBoxModule } from './checkbox/checkbox.module';
import { CompanyFormCheckboxComponent } from './company-form-checkbox/company-form-checkbox.component';
import {
  DialogAlertSelectConditionMonitorComponent,
} from './dialog-alert-select-condition-monitor/dialog-alert-select-condition-monitor.component';
import { DialogRemoveComponent } from './dialog-remove/dialog-remove.component';
import { DialogSpinnerDownloadModule } from './dialog-spinner-download/dialog-spinner-download.module';
import { EligibleModule } from './eligible/eligible.module';
import { ListLegendComponent } from './list-legend/list-legend.component';
import { LoadersModule } from './loaders/loaders.module';
import { Ng2FileDropComponent } from './ng2-file-drop/ng2-file-drop.component';
import { RangeDatePickerComponent } from './range-date-picker/range-date-picker.component';
import { SingleDatePickerComponent } from './single-date-picker/single-date-picker.component';
import { StarRatingComponent } from './star-rating/star-rating.component';
import { TooltipMatComponent } from './tooltip-mat/tooltip-mat.component';
// import { Daterangepicker } from 'ng2-daterangepicker';
import { DialogDownloadCsvComponent } from './dialog-download-csv/dialog-download-csv.component';
import { DialogSpinnerComponent } from './dialog-spinner/dialog-spinner.component';
import { AreasOfLifeCheckboxComponent } from "@app-shared/components/areas-of-life-checkbox/areas-of-life-checkbox.component";
import { PublicationAttachmentComponent } from './publication-attachment/publication-attachment.component';
import { MatRadioModule } from '@angular/material/radio';
import { DialogConfirmComponent } from './dialog-confirm/dialog-confirm.component';
import { MapsAutocompleteComponent } from './maps-autocomplete/maps-autocomplete.component';
import { ImageCropperWrapperModule } from '@app/wrapper-modules/image-cropper.module';
import { CircleProgressComponent } from './circle-progress/circle-progress.component';
const components = [
	CircleProgressComponent,
	BtnLoadingComponent,
	Ng2FileDropComponent,
	StarRatingComponent,
	ListLegendComponent,
	TooltipMatComponent,
	DialogAlertSelectConditionMonitorComponent,
	DialogRemoveComponent,
	CheckboxSelectComponent,
	CheckboxSelectFilterComponent,
	CompanyFormCheckboxComponent,
	RangeDatePickerComponent,
	SingleDatePickerComponent,
	DialogDownloadCsvComponent,
	DialogSpinnerComponent,
	AreasOfLifeCheckboxComponent,
	PublicationAttachmentComponent,
	DialogConfirmComponent,
	MapsAutocompleteComponent,
	FileDialogComponent
];

@NgModule({
	imports: [
		ImageCropperWrapperModule,
		CommonModule,
		RouterModule,
		SharedPipesModule,
		SharedDirectivesModule,
		NgbModule,
		FileUploadModule,
		MatProgressSpinnerModule,
		FormsModule,
		MatDialogModule,
		MatInputModule,
		MatTooltipModule,
		MatButtonModule,
		MatSelectModule,
		ReactiveFormsModule,
		CheckBoxModule,
		MatCheckboxModule,
		MatIconModule,
		EligibleModule,
		MatRadioModule,
	],
	declarations: components,
	exports: [...components, LoadersModule, DialogSpinnerDownloadModule]
})
export class SharedComponentsModule {}
